export function share (val, receiveGift, gotoApp) {
	if (val.value !== '') {
		if (val.type === 'received') {
			receiveGift(val.value)
		} else if (val.type === 'gotoApp') {
			gotoApp(val.value)
		} else if (val.type === 'link') {
			window.location.href = val.value
		}
	}
}

export function sharefriend (shareData, sharingrewards) {
	const ua = navigator.userAgent.toLowerCase()
	if (/micromessenger/ig.test(ua) || / QQ/ig.test(ua)) {
		const name = / QQAPPID/ig.test(ua) ? '请在手机QQ或微信下打开活动页面再进行分享操作。' : '请通过右上方进行分享哦'
		alert(name)
	} else {
		alert('请通过浏览器分享功能进行分享哦')
	}
	let shareAppMessageData = {
		wx_appid: 'wxfb66a4e99e630765',
		title: shareData.title,
		desc: shareData.description,
		link: shareData.href ? shareData.href : window.location.href,
		imgUrl: shareData.icon,
		WXtrigger: function (res) { // 微信点击事件回调
			console.log('微信点击回调' + JSON.stringify(res))
		},
		WXsuccess: function (res) { // 微信分享成功回调
			console.log('微信分享成功回调' + JSON.stringify(res));
			sharingrewards()
		},
		WXcancel: function (res) { // 微信分享取消回调
			console.log('微信分享取消回调' + JSON.stringify(res));
		},
		WXfail: function (res) { // 微信分享失败回调
			console.log('微信分享失败回调' + JSON.stringify(res));
		},
		QQcallback: function (res) { // qq成功、失败、或取消的回调
			console.log('QQ分享之后回调回调' + JSON.stringify(res));
			sharingrewards()
		},
		QQtrigger: function (res) { // qq触发事件的回调
			console.log('QQ分享触发回调' + JSON.stringify(res));
		},
		qqBrowserCallback: function (data) {
			console.log('QQ浏览器分享触发回调' + JSON.stringify(data));
		},
	}
	window.need('biz.mobileclient', function (mClient) {
		mClient.shareAll(shareAppMessageData);
	});
}



// WEBPACK FOOTER //
// ./src/components/actModules/h5/templates/lottery/index.js